// extracted by mini-css-extract-plugin
export default {"shelf-title":"ShelfTitle-styles-module__shelf-title__IMkwV","shelfTitle":"ShelfTitle-styles-module__shelf-title__IMkwV"};